import { useMemo } from 'react';
import { getPmmModel } from '../pmm';

export enum PoolTemplate {
  standard = 1,
  singleToken,
  pagged,
  // private pool
  marketMaker,
}

export const useCreatePmm = ({
  poolTemplate,
  baseAmount,
  quoteAmount,
  initPrice,
  slippageCoefficient,
}: {
  poolTemplate: PoolTemplate;
  baseAmount?: string;
  quoteAmount?: string;
  initPrice: string;
  slippageCoefficient: string;
}) => {
  const pmmParams = useMemo(() => {
    const isPublic = [PoolTemplate.standard, PoolTemplate.singleToken].includes(
      poolTemplate,
    );
    const isSingle = poolTemplate === PoolTemplate.singleToken;

    if (!baseAmount || (!isSingle && !quoteAmount)) return undefined;
    const i = Number(initPrice);
    // 目前私有池都是自定义，所以不考虑这种情况
    // if (quoteAmount && baseAmount && isPrivate && isStandardTemplate) {
    //   i = quoteAmount / baseAmount;
    // }
    const baseAmountNumber = Number(baseAmount);
    const quoteAmountNumber = Number(quoteAmount);
    const slippageCoefficientNumber = Number(slippageCoefficient);
    return {
      i,
      k: slippageCoefficientNumber,
      b: baseAmountNumber,
      b0: baseAmountNumber,
      q: quoteAmountNumber,
      q0: slippageCoefficientNumber === 0 || !isPublic ? quoteAmountNumber : 0,
      R: slippageCoefficientNumber === 0 || !isPublic ? 0 : 1,
    };
  }, [poolTemplate, baseAmount, quoteAmount, initPrice, slippageCoefficient]);

  const pmmModel = useMemo(() => {
    if (!pmmParams) return undefined;
    return getPmmModel(pmmParams);
  }, [pmmParams]);

  const midPrice = useMemo(() => {
    if (!pmmModel) return undefined;
    return pmmModel.getMidPrice();
  }, [pmmModel]);

  return {
    pmmParams,
    pmmModel,
    midPrice,
  };
};
